import React, { useEffect, useState  } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import HeroSection from "../../components/heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import { FaLock } from "react-icons/fa";
import "../registerDriverPage/RegisterDriverPage.css";
import Footer from "../footer/Footer";
import { authAPI } from "../../api/apiSystem";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { email, token } = useParams();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email || !token) {
      Swal.fire({
        icon: 'error',
        title: t("resetPassword.error.invalidLinkTitle"),
        text: t("resetPassword.error.invalidLinkText"),
        confirmButtonText: t("common.ok"),
        confirmButtonColor: '#ffc107'
      });
      return;
    }
  }, [email, token, t]);

  const showSuccessAlert = (message) => {
    Swal.fire({
      icon: 'success',
      title: t("resetPassword.successTitle"),
      text: message,
      confirmButtonText: t("common.ok"),
      confirmButtonColor: '#28a745',
      timer: 3000,
      timerProgressBar: true
    });
  };

  const showErrorAlert = (message) => {
    Swal.fire({
      icon: 'error',
      title: t("resetPassword.errorTitle"),
      text: message,
      confirmButtonText: t("common.ok"),
      confirmButtonColor: '#dc3545'
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      showErrorAlert(t("resetPassword.error.passwordMismatch"));
      return;
    }

    setLoading(true);

    try {
      const res = await authAPI.resetPassword({
        email,
        token,
        new_password: newPassword,
        new_password_confirmation: confirmPassword,
      });

      if (res.success) {
        showSuccessAlert(t("resetPassword.success"));
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        showErrorAlert(res.message || t("resetPassword.error.generic"));
      }
    } catch (err) {
      showErrorAlert(t("resetPassword.error.serverFailure"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HeroSection
        backgroundImage={heroPhoto}
        title={t("resetPassword.heroSection.title")}
        titleHighlight={t("resetPassword.heroSection.titleHighlight")}
        showTopbar={false}
        showNavbar={true}
        features={t("resetPassword.heroSection.features", { returnObjects: true })}
        showQuoteForm={false}
        showCTAButton={false}
        customHeight="100%"
      />

      <div className="dark-bg-primary register-driver-section">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="shadow-lg p-4 border-0 register-driver-card">
                <Card.Body>
                  <h4 className="text-center mb-4 text-dark fw-bold">
                    {t("resetPassword.title")}
                  </h4>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="hidden"
                        value={decodeURIComponent(email || '')}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="hidden"
                        value={token || ''}
                      />
                    </Form.Group>

                    <Form.Group controlId="formNewPassword" className="mb-3">
                      <Form.Label>{t("resetPassword.newPasswordLabel")}</Form.Label>
                      <div className="position-relative">
                        <FaLock className="form-icon" />
                        <Form.Control
                          type="password"
                          placeholder={t("resetPassword.newPasswordPlaceholder")}
                          className="ps-5"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
                      </div>
                    </Form.Group>

                    <Form.Group controlId="formConfirmPassword">
                      <Form.Label>{t("resetPassword.confirmPasswordLabel")}</Form.Label>
                      <div className="position-relative">
                        <FaLock className="form-icon" />
                        <Form.Control
                          type="password"
                          placeholder={t("resetPassword.confirmPasswordPlaceholder")}
                          className="ps-5"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </div>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="warning"
                      disabled={loading}
                      className="w-100 mt-4 bg-orange-500 text-white"
                    >
                      {loading ? t("resetPassword.submitButtonLoading") : t("resetPassword.submitButton")}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
}